import { instance } from "./../helpers/http/apiclient";

export async function emailQueue() {
  return db.collection("EmailQueue").get();
}
export async function getCompanyProfile(storeId) {
  return instance.get("bookings/" + storeId + "/profile");
}
export async function getAvailableTimes(storeId, date) {
  return instance.get("bookings/" + storeId + "/available?startAt=" + date);
}
export async function getAvailableDays(storeId,month) {
  return instance.get("bookings/" + storeId + "/availabledays?month="+month);
}
export async function getStoreStripeStatus(storeId) {
  return instance.post("stripepayment/enabled", {storeId});
}
export function setBookingInfo(bookingInfo) {
  return instance.post("bookings/" + bookingInfo.Uuid, bookingInfo);
}
export function createTempBooking(bookingInfo) {
  return instance.post(`bookings/${bookingInfo.Uuid}/create`, bookingInfo);
}
